import {
  Alert,
  Grid,
  Stack,
  Table,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from '@mui/material';
import {iTimedMessageMessageItem} from './TimedMsgRequestContentMessageCard';
import {IMediaTrack} from '../../../../../dto/MediaTrack.dto';
import MusicSelectionTable from '../../../../../components/music/MusicSelectionTable';
import {IStation} from '../../../../../dto/Station.dto';

type Props = {
  message: iTimedMessageMessageItem;
  onChange: (newMessage: iTimedMessageMessageItem) => void;
  type?: string;
  label?: string;
  selectedStations?: IStation[];
};

const TimedMsgRequestContentSongCard = ({
  onChange,
  message,
  type,
  label,
  selectedStations,
}: Props) => {
  const handleSelect = (track: IMediaTrack) => {
    onChange({
      ...message,
      artist: '',
      title: '',
      file: undefined,
      track,
      isNew: true,
    });
  };
  const handleDeselect = () => {
    onChange({
      ...message,
      artist: '',
      title: '',
      file: undefined,
      track: undefined,
    });
  };
  return (
    <Grid
      container
      spacing={1}
      className={`w-full ${
        type === 'sequence' ? 'black-variant1 px-2 pb-2 radius-5' : ''
      }`}>
      <Grid item xs={12} className='w-full'>
        <MusicSelectionTable
          selectedTracks={message.track ? [message.track] : []}
          onSelect={handleSelect}
          onChange={onChange}
          message={message}
          onDeselect={handleDeselect}
          slots={{}}
          title={label ? `Select ${label}` : 'Timed Songs'}
          selectedStations={selectedStations}
          selection_type='timed-message'
          isTrackWithoutGenreRestriction={false}
        />
      </Grid>
      {(message.id > 0 && !message.track) || message.track ? (
        <Grid
          item
          xs={12}
          className='p-5 radius-10 blue-variant4 flex items-center justify-center'>
          {message.id > 0 && !message.track ? (
            <Stack direction='column' spacing={2}>
              <Alert severity='warning'>
                Selecting song will delete the the song-request which is
                In-progress
              </Alert>
              <Typography align='center'>
                Song request is In-progress
              </Typography>
            </Stack>
          ) : (
            <>{message.track && <SelectedSongCmpt track={message.track} />}</>
          )}
        </Grid>
      ) : null}
    </Grid>
  );
};

export default TimedMsgRequestContentSongCard;

function SelectedSongCmpt({track}: Readonly<{track: IMediaTrack}>) {
  return (
    <TableContainer>
      <Table>
        <TableRow>
          <TableCell className='w-200'>
            <Typography variant='h6' className='text-white-50'>
              Title
            </Typography>
          </TableCell>
          <TableCell>
            {' '}
            <Typography variant='h6' className='text-white-50'>
              Artist
            </Typography>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell>
            <Typography>{track?.track_artist}</Typography>
          </TableCell>
          <TableCell>
            <Typography>{track?.track_name}</Typography>
          </TableCell>
        </TableRow>
      </Table>
    </TableContainer>
  );
}
